import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { AuthGuard } from './modules/core/services/authentication/auth-guard';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { TokenInterceptor } from './modules/core/interceptor/token/token.interceptor';
import { MatDialogModule } from '@angular/material/dialog';
import { CalendarModule } from 'angular-calendar';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    MatDialogModule,
    CalendarModule
  ],
  providers: [{ 
  provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, 
  DatePipe,
  AuthGuard,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
